module.exports = __webpack_public_path__ + "static/img/banner1.0a08572.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner1.jpg
// module id = NvTC
// module chunks = 0